import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';

function MomentsGallery({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((m, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure className="group relative h-72 rounded-3xl overflow-hidden shadow-soft">
                <EditableImage
                  src={m.image?.src}
                  alt={m.image?.alt || m.caption}
                  onChange={(src, alt) => updateItem(i, { image: { src, alt } })}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-olive-footer/85 via-transparent to-transparent" />
                <EditableText value={m.caption} onChange={(t) => updateItem(i, { caption: t })} as="figcaption" className="absolute inset-x-0 bottom-0 p-5 text-white font-display text-lg" />
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MomentsGallery;
